<template>
    <v-row justify="center">
      <v-dialog v-model="shower" scrollable persistent max-width="1200px">
        <v-card>
          <!-- <v-card-title v-if="$t('default') === 'th'"
            >{{ $t("admintoolbar.mydriveadmin") }}&nbsp;{{ data_employee.user_name_th }}&nbsp;</v-card-title
          >
          <v-card-title v-else>{{ $t("admintoolbar.mydriveadmin") }}&nbsp;{{ data_employee.user_name_en }}&nbsp;</v-card-title> -->
          <v-divider></v-divider>
          <v-card-text style="height:800px">
            <v-layout row wrap class="pa-2">
              <v-flex xs12 lg12>
            <v-overlay :value="loadprogress" absolute :color="color.BG" dark>
              <v-progress-circular indeterminate size="64" :color="color.theme"></v-progress-circular>
              <!-- <span :style="colorProgress">&nbsp; loading</span> -->
            </v-overlay>
            <br />
            <v-list nav>
              <v-list-item class="text-left">
                <v-list-item-avatar class="text-center">
                  <v-avatar :color="color.theme" size="35">
                    <v-icon dark size="20">mdi-account-multiple-plus</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                      <span :style="headerPage"
                        >&nbsp; Group &nbsp; {{ data_group.group_name }}</span
                      >
                    </v-list-item-title>
                  </v-list-item-content>
                <v-list-item-group>
                  <!-- <v-list-item-action> -->
                  <!-- <v-btn icon fab small text @click="backtopreventfolder()" :color="color.theme">
                    <v-icon>keyboard_backspace</v-icon>
                  </v-btn> -->
                  <!-- </v-list-item-action> -->
                </v-list-item-group>
              </v-list-item>
            </v-list>
            <v-layout>
                <v-flex lg2 md4 xs9 class="mr-2">
                  <v-text-field
                    v-model="search_employee"
                    class="pl-1"
                    :label="$t('admin.search')"
                    clearable
                    outlined
                    dense
                    :color="color.theme"
                    append-icon="search"
                    @click:clear="(search_employee = ''), fn_load_employee()"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 xs2 class="pl-1">
                  <v-btn
                    :color="color.theme"
                    :dark="color.darkTheme"
                    @click="fn_load_employee(search_employee)"
                    >{{ $t("admin.search") }}</v-btn
                  >
                </v-flex>
              </v-layout>
            <v-layout>
              <!-- <v-btn>ดาวน์โหลดทั้งหมด</v-btn><v-btn>ลบทั้งหมด</v-btn> -->
            </v-layout>
            <div v-if="loaddataprogresstable === true">
              <v-flex lg12 class="ma-2 ml-4 mr-4">
                <div class="text-center">
                  <!-- <v-progress-circular :size="50" :color="color.theme" indeterminate></v-progress-circular> -->
                  <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
                </div>
              </v-flex>
            </div>
            <div v-else>
              <div v-if="resolutionScreen >= 500">
                <v-data-table
                  :headers="headers"
                  :items="data"
                  item-key="user_id"
                  :single-select="false"
                  class="elevation-0"
                  item-selected
                  :page.sync="page"
                  :items-per-page="size"
                  :hide-default-footer="true"
                  @page-count="pageCount = $event"
                  :no-data-text="$t('tablefile.empty')"
                >
                  <template v-slot:[`header.account_id`]="{ header }">
                    <span :style="headerTable">{{ header.text }}</span>
                  </template>
                  <template v-slot:[`header.first_name_th`]="{ header }">
                    <span class="pointer" :style="headerTable">{{ $t(header.text) }}</span>
                  </template>
                  <template v-slot:[`header.email`]="{ header }">
                    <span class="pointer" :style="headerTable">{{ $t(header.text) }}</span>
                  </template>
                  <template v-slot:[`header.username`]="{ header }">
                    <span class="pointer" :style="headerTable">{{ $t(header.text) }}</span>
                  </template>
                  <template v-slot:[`header.status`]="{ header }">
                    <span class="pointer" :style="headerTable">{{ $t(header.text) }}</span>
                  </template>
                  <template v-slot:[`header.tel_no`]="{ header }">
                    <span :style="headerTable">{{ $t(header.text) }}</span>
                  </template>
                  <template v-slot:item="props">
                    <tr style="cursor: pointer" @dblclick="gotodirectory(props.item.file_id, props.item.file_type, props.item)">
                      <td width="7%" class="text-center">
                        <v-icon large :color="color.theme">mdi-account</v-icon>
                      </td>
                      <td width="14%" v-if="$t('default') === 'th'">
                        {{ props.item.first_name_th + " " + props.item.last_name_th}}
                      </td>
                      <td width="14%" v-else>
                        {{ props.item.first_name_eng + " " + props.item.last_name_eng}}
                      </td>
                      <td width="15%">{{ props.item.email  }}</td>
                      <td width="15%">{{ props.item.username }}</td>
                      <td width="15%">{{ props.item.status === false ? 'ไม่อยู่ใน Group' : 'อยู่ใน Group'}}</td>
                      <td width="15%" class="text-center">
                        <v-btn class="elevation-0  white--text" :color="color.theme"  small @click="fn_employee_group(props.item)" :disabled=" props.item.status === true">
                          <v-icon>mdi-account-plus</v-icon> {{$t('group_.adduseringroup')}}
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <div v-else>
                <v-list two-line class="mb-6 pb-6 elevation-0" v-if="this.count_data !== 0">
                  <v-list-item v-for="item in data" :key="item.title" style="cursor: pointer;">
                    <v-list-item-action>
                      <v-icon large :color="color.theme">mdi-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-if="$t('default') === 'th'" v-text="item.first_name_th"></v-list-item-title>
                      <v-list-item-title v-else v-text="item.first_name_eng"></v-list-item-title>
                      <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn class="elevation-0  white--text" :color="color.theme"  small @click="fn_employee_group(item)" :disabled=" item.status === true">
                          <v-icon>mdi-account-plus</v-icon> {{$t('group_.adduseringroup')}}
                        </v-btn>
                      <!-- <v-btn class="elevation-0" fab small @click="confirmdelete(props.item)">
                        <v-icon>delete</v-icon>
                      </v-btn> -->
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-list v-else class="mb-6 pb-6 elevation-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="text-center" v-text="$t('tablefile.empty')"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </div>
            <v-layout row wrap justify-center>
              <v-flex xs11 lg11 v-if="pageCount > 0">
                <v-pagination
                  :total-visible="10"
                  v-model="page"
                  :length="pageCount || 0"
                  :color="color.theme"
                  @input="clickpagination()"
                ></v-pagination>
              </v-flex>
            </v-layout>
            <v-card-text> </v-card-text>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="$emit('close'),search_employee = ''" >{{ $t("admin.close") }}</v-btn>
            <!-- <v-btn :color="color.theme" :dark="color.darkTheme" @click="settingfeature()">{{ $t("admin.submit") }}</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
     
    </v-row>
  </template>
  <script>
  import { mapState, mapGetters } from "vuex";
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import "sweetalert2/src/sweetalert2.scss";
  import { validationMixin } from "vuelidate";
  import { required, maxLength, email } from "vuelidate/lib/validators";
  import gbfGenerate from "@/globalFunctions/generateAuthorize";
  import gbfdecodearraybuffer from "@/globalFunctions/decodearraybuffer";
  import gb_sizeDataConverter from "@/globalFunctions/sizeDataConverter";

  
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
  });
  
  export default {
    mixins: [validationMixin],
    validations: {
      filename: { required },
    },
    props: ["show", "data_group"],
    components: {  },
    data: function() {
      return {
        search_employee:"",
        parentfolder: "",
        currentfile: {},
        openpreviewfile: false,
        navigate: [],
        file: {},
        percent: 0,
        datetime: "",
        opensnackbardownloadfile: false,
        opensnackbarmultidownload: false,
        opensnackbar: false,
        newpercen: [],
        namefile: "",
        new_list: [],
        newlist: [],
        dataIndex: "",
        datadowload: {},
        listdatadowload: [],
        listdowload: [],
        listdatadowload: [],
        newlist: [],
        btsdownload: false,
        percentCompleted: 0,
        count_data: 0,
        size: 20,
        page: 1,
        data: [],
        headers: [
          {
            text: "#",
            align: "left",
            value: "account_id",
            width: "7%",
            sortable: false,
          },
          {
            text: "addemployee.addemployee_name",
            value: "first_name_th",
            width: "30%",
            align: "left",
            sortable: false,
          },
        //   {
        //     text: "addemployee.addemployee_lastname",
        //     value: "last_name_th",
        //     width: "14%",
        //     align: "left",
        //     sortable: false,
        //   },
          {
            text: "addemployee.addemployee_email",
            value: "email",
            width: "15%",
            align: "center",
            sortable: false,
          },
          {
            text: "addemployee.addemployee_username",
            value: "username",
            width: "15%",
            align: "left",
            sortable: false,
          },
          {
            text: "addemployee.addemployee_status",
            value: "status",
            width: "15%",
            align: "left",
            sortable: false,
          },
          {
            text: "addemployee.setting",
            value: "tel_no",
            width: "15%",
            align: "center",
            sortable: false,
          },
        ],
        SWmydrive: false,
        SWmyinbox: false,
        SWmyoutbox: false,
        SWshare: false,
        SWtrash: false,
        SWstared: false,
        createprogress: false,
        nametitle: "",
        selectall: false,
        switchfeature: "",
        feature: [],
        selected: [],
        test: 1,
        loadprogress: false,
        loaddataprogresstable: false,
      };
    },
    computed: {
      ...mapState(["username", "authorize", "account_active", "color", "role_level"]),
      ...mapState({ processloader: "loading" }),
      ...mapGetters([
        "dataUsername",
        "dataAuthorize",
        "dataAccountActive",
        "dataAccesstoken",
        "dataBusinessProfile",
        "dataCitizenProfile",
        "dataDepartmentAccessId",
        "dataAccountId",
      ]),
      resolutionScreen() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return 220;
          case "sm":
            return 400;
          case "md":
            return 500;
          case "lg":
            return 600;
          case "xl":
            return 800;
        }
      },
      shower: {
        get() {
          if (this.show === true) {
            console.log("data_group",this.data_group);
            this.fn_load_employee();

          }
          return this.show;
        },
        set(value) {
          if (!value) {
            this.selected = [];
          }
        },
      },
      pageCount: {
        get() {
          let l = this.count_data;
          let s = this.size;
          console.log("Math.ceil(l / s);",Math.ceil(l / s));
          return Math.ceil(l / s);
        },
        set(newName) {
          return newName;
        },
      },
      colorProgress() {
        return "color:" + this.color.theme + ";";
      },
      headerTable() {
        return "color:" + this.color.theme + ";" + "font-weight: 600; font-size:15px;";
      },
      headerPage() {
        // console.log(this.color.theme);
  
        return "color:" + this.color.theme + ";" + "font-size: 18px; font-weight: 600;";
      },
    },
  
    methods: {
      formatdatetime(_datetime) {
        if (_datetime === "" || _datetime === "-" || _datetime === undefined || _datetime === null) {
          return "-";
        } else {
          let dateyear = _datetime.split("")[0] + _datetime.split("")[1] + _datetime.split("")[2] + _datetime.split("")[3];
          let datemonth = _datetime.split("")[4] + _datetime.split("")[5];
          let dateday = _datetime.split("")[6] + _datetime.split("")[7];
          let hour = _datetime.split("")[8] + _datetime.split("")[9];
          let minute = _datetime.split("")[10] + _datetime.split("")[11];
          let second = _datetime.split("")[12] + _datetime.split("")[13];
  
          return dateday + "/" + datemonth + "/" + dateyear + " " + hour + ":" + minute + ":" + second;
        }
      },

      clickpagination() {
        this.fn_load_file_employee();
      },
      
      async fn_load_employee() {
        this.loaddataprogresstable = true;
        this.data = [];

        let payload = {
          business_id: this.dataAccountActive.business_info.business_id,
          account_id: this.dataAccountId,
          group_id: this.data_group.id,
          search : this.search_employee
         
        };
        let auth = await gbfGenerate.generateToken();
        this.axios
        //   .post(process.env.VUE_APP_SERVICE_ADMIN + "/api/admin/list_user_group", payload, {
        //     headers: { Authorization: auth.code },
        //   })
          .post("https://f9300388b7d4.ngrok-free.app/api/admin/list_user_group", payload, {
            headers: { Authorization: auth.code },
          })
          .then((response) => {
            console.log(response);
            if (response.data.status === "OK") {
                console.log("response",response);
              this.loaddataprogresstable = false;
              this.count_data = response.data.data_group.data.length;;
              for (let i = 0; i < response.data.data_group.data.length; i++) {
                let dataemployee = {};
                dataemployee["email"] = response.data.data_group.data[i]["email"];
                dataemployee["first_name_eng"] = response.data.data_group.data[i]["first_name_eng"];
                dataemployee["first_name_th"] = response.data.data_group.data[i]["first_name_th"];
                dataemployee["last_name_eng"] = response.data.data_group.data[i]["last_name_eng"];
                dataemployee["last_name_th"] = response.data.data_group.data[i]["last_name_th"];
                dataemployee["status"] = response.data.data_group.data[i]["status"];
                dataemployee["tel_no"] = response.data.data_group.data[i]["tel_no"];
                dataemployee["thai_email"] = response.data.data_group.data[i]["thai_email"];
                dataemployee["user_id"] = response.data.data_group.data[i]["user_id"];
                dataemployee["username"] = response.data.data_group.data[i]["username"];
                dataemployee["account_id"] = response.data.data_group.data[i]["account_id"];
  
                this.data.push(dataemployee);
              }
              console.log(this.data, "his.file_dat");
            }else{
              Toast.fire({
              icon: "error",
              title: response.data.status + ": " + response.data.errorMessage,
            });
            }
          }).catch((error) => {
            console.log(error);
            this.loaddataprogresstable = false;
           
            Toast.fire({
              icon: "error",
              title: "ไม่สามารถเชื่อมต่อไปที่ ONE-BOX ได้ในขณะนี้",
            });
          });
      },

      async fn_employee_group(item){
        console.log("item",item);
        
        let payload = {
          business_id: this.dataAccountActive.business_info.business_id,
          account_id: this.dataAccountId,
          group_id: this.data_group.id,
          group_users : [item.account_id],
        };
        let auth = await gbfGenerate.generateToken();
        this.axios
        // .post(
        //   process.env.VUE_APP_SERVICE_DOWNLOAD_API + "/api/change_name/data",
        //   payload,
        //   { headers: { Authorization: auth.code } }
        // )
        .post(" https://f9300388b7d4.ngrok-free.app/api/admin/add_user_group",
          payload,
          { headers: { Authorization: auth.code } }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status === "OK") {
            console.log("response111",response);
            
            let msgres = response.data.message
            Toast.fire({
              icon: "success",
              title: msgres,
            });
            this.$emit("reload");
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.errorMessage,
            });
          }
          this.createprogress = false;
        })
        .catch((error) => {
          console.log(error);
          Toast.fire({
            icon: "error",
            title: this.$t("changeName.noChange"),
            //title: "ไม่สามารถแก้ไขชื่อ"  + this.filedata.file_name + "ได้"
          });
          this.createprogress = false;
        });
        
      }


    },
  };
  </script>
  <style></style>
  